import { createColumnHelper } from "@tanstack/react-table";
import { Link } from "react-router-dom";

const columnHelper = createColumnHelper<any>();

const StatusPill = ({ status }: { status: string }) => {
  return (
    <span className="inline-flex items-center justify-center px-4 py-1 rounded-full border border-[#12B76A] text-[#027A48] text-xs font-medium bg-[#ECFDF3]">
      {status}
    </span>
  );
};

const JudgePill = ({ label }: { label: string }) => {
  return (
    <span className="inline-flex items-center justify-center px-4 py-1 rounded-full bg-[#F2F4F7] text-[#101828] text-xs">
      {label}
    </span>
  );
};

const AdminPill = () => {
  return (
    <span className="inline-flex items-center justify-center px-4 py-1 rounded-full bg-[#1D4ED8] text-white text-xs font-medium">
      Admin
    </span>
  );
};

export const PresidentPanelsColumns = [
  columnHelper.accessor("sn", {
    header: "SN",
    cell: (info) => (
      <span className="text-[#101828]">{info.row.index + 1}</span>
    ),
  }),
  columnHelper.accessor("panel_name", {
    header: "Panel Name",
    cell: (info) => (
      <span className="text-[#101828] font-medium">{info.getValue()}</span>
    ),
  }),
  columnHelper.accessor("judges", {
    header: "Honorable  Judges",
    cell: (info) => {
      const judges = info.getValue() as string[];
      const admin = info.row.original.admin as string;

      return (
        <div className="flex flex-wrap gap-2">
          {judges.map((judge) => (
            <JudgePill key={judge} label={judge} />
          ))}
          {admin && <AdminPill />}
        </div>
      );
    },
  }),
  columnHelper.accessor("court_number", {
    header: "Court number",
    cell: (info) => <span className="text-[#101828]">{info.getValue()}</span>,
  }),
  columnHelper.accessor("subject_matter", {
    header: "Subject matter",
    cell: (info) => <span className="text-[#101828]">{info.getValue()}</span>,
  }),
  columnHelper.accessor("status", {
    header: "Status",
    cell: (info) => <StatusPill status={info.getValue() as string} />,
  }),
  columnHelper.accessor("docket", {
    header: "Docket",
    cell: () => (
      <Link
        to="/president/panels/docket"
        className="text-[#00B074] text-sm font-medium"
      >
        View
      </Link>
    ),
  }),
  columnHelper.display({
    id: "action",
    header: "Action",
    cell: () => (
      <button className="text-[#00B074] text-sm font-medium">Assign</button>
    ),
  }),
];
